import {
  errorAction,
  requestAction,
  successAction,
  types,
} from "@authzsvc/api-lib";

const initialState = {
  loading: false,
  data: [],
};

const serviceCollections = (state = initialState, action) => {
  switch (action.type) {
    case errorAction(types.GET_SERVICE_COLLECTIONS_WITH_ELIGIBLITY_STATUS):
      return {
        ...state,
        loading: false,
      };
    case successAction(types.GET_SERVICE_COLLECTIONS_WITH_ELIGIBLITY_STATUS):
      return {
        ...state,
        data: action.payload.data,
        loading: false,
      };
    case requestAction(types.GET_SERVICE_COLLECTIONS_WITH_ELIGIBLITY_STATUS):
      return {
        ...state,
        data: [],
        loading: true,
      };
    default:
      return state;
  }
};

export default serviceCollections;
